
import { api } from "./configs/axiosConfigs"
import { defineCancelApiObject } from "./configs/axiosUtils"

export const CategoryAPI = {

  getAll: async function (cancel = false) {
    const response = await api.request({
      url: "/api/categories",
      method: "GET",
      signal: cancel ? cancelApiObject[this.getAll.name].handleRequestCancellation().signal : undefined,
    })
    return response.data
  },
  create: async function (category, cancel = false) {
    const response = await api.request({
      url: `/api/admin/categories`,
      method: "POST",
      data: category,
      headers: { "Content-Type": "multipart/form-data" },
      signal: cancel ? cancelApiObject[this.create.name].handleRequestCancellation().signal : undefined,
    })
    return response.data;
  },
  delete: async function (id, cancel = false) {
    const response = await api.request({
      url: `/api/admin/categories/${id}`,
      method: "DELETE",
      signal: cancel ? cancelApiObject[this.delete.name].handleRequestCancellation().signal : undefined,
    })
    return response.data;
  },
  get: async function (id,cancel = false) {
    const response = await api.request({
      url: `/api/admin/categories/${id}`,
      method: "GET",
      signal: cancel ? cancelApiObject[this.get.name].handleRequestCancellation().signal : undefined,
    })
    return response.data
  },
  update: async function (category,id,cancel = false) {
    const response = await api.request({
      url: `/api/admin/categories/${id}`,
      method: "POST",
      data: category,
      headers: { "Content-Type": "multipart/form-data" },
      signal: cancel ? cancelApiObject[this.update.name].handleRequestCancellation().signal : undefined,
    })
    return response.data
  },
}

const cancelApiObject = defineCancelApiObject(CategoryAPI)